import { ulid } from 'ulid';

export const generateId = (): string => {
  // crypto.randomUUID might not be available on old iPads
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return globalThis.crypto?.randomUUID?.() ?? ulid();
};
